<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Booking Type</span>
      <div>
        @if (itemTreeBookingTypeForm.value !== null) {
          <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
          </eas-editor-booking-item-inheritable-type-badge>
        }
        @if (isDeletable()) {
          <button
            mat-icon-button
            aria-label="Delete booking type"
            i18n-aria-label
            (click)="onDelete()">
            <mat-icon inline>delete</mat-icon>
          </button>
        }
      </div>
    </div>
  </legend>
  <p i18n>
    Please define the type of the booking you are creating.
  </p>
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label i18n>Booking type</mat-label>
      <mat-select id="booking-type" formControlName="bookingType">
        @for (option of bookingTypeNames; track option) {
          <mat-option [value]="option.id">
            {{ option.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</fieldset>
